const API_BASE = import.meta.env.VITE_API_BASE ?? "http://localhost:8787";

const hasLocalStorage = () =>
  typeof window !== "undefined" && typeof globalThis.localStorage !== "undefined";

let token: string | null = null;

if (hasLocalStorage()) {
  token = globalThis.localStorage.getItem("aics_token");
}

export function setToken(t: string | null) {
  token = t;
  if (!hasLocalStorage()) return;
  if (t) globalThis.localStorage.setItem("aics_token", t);
  else globalThis.localStorage.removeItem("aics_token");
}

export function getToken() {
  return token;
}

async function request<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers: Record<string, string> = { "Content-Type": "application/json", ...(init.headers as any) };
  if (token) headers.Authorization = `Bearer ${token}`;
  const res = await fetch(`${API_BASE}${path}`, { ...init, headers });
  if (!res.ok) throw new Error((await res.json().catch(() => ({})))?.error ?? `HTTP ${res.status}`);
  return res.json();
}

export const api = {
  // auth
  register: (data: { username: string; password: string; inviteCode: string }) =>
    request<{ token: string; user: { id: string; username: string; isAdmin: boolean } }>("/auth/register", {
      method: "POST",
      body: JSON.stringify(data)
    }),
  login: (data: { username: string; password: string }) =>
    request<{ token: string; user: { id: string; username: string; isAdmin: boolean } }>("/auth/login", {
      method: "POST",
      body: JSON.stringify(data)
    }),
  me: () => request<{ user: { id: string; username: string; isAdmin: boolean } }>("/me"),

  // ideas
  listIdeas: () => request<any[]>("/ideas"),
  createIdea: (data: { title: string; summary: string; tags?: string[] }) =>
    request<any>("/ideas", { method: "POST", body: JSON.stringify(data) }),
  voteIdea: (id: string) => request<{ ok: boolean; votes: number }>(`/ideas/${id}/vote`, { method: "POST" }),

  // comments
  listComments: (ideaId: string) => request<any[]>(`/comments/${ideaId}`),
  addComment: (ideaId: string, body: string) =>
    request(`/comments/${ideaId}`, { method: "POST", body: JSON.stringify({ body }) }),

  // invites (admin)
  listInvites: () => request<any[]>("/invites"),
  createInvite: () => request<any>("/invites", { method: "POST" }),
  deleteInvite: (code: string) => request(`/invites/${code}`, { method: "DELETE" }),
  verifyInvite: (code: string) =>
    request<{ valid: boolean; code: string }>("/invites/verify", { method: "POST", body: JSON.stringify({ code }) }),

  // users (admin)
  listUsers: () => request<any[]>("/users"),
  toggleUserActive: (id: string) => request<any>(`/users/${id}/toggle-active`, { method: "POST" }),
  toggleUserAdmin: (id: string) => request<any>(`/users/${id}/toggle-admin`, { method: "POST" })
};
